module.exports = __webpack_public_path__ + "static/headshot-3cbdd6e06ac7e4baea99b590637950b0.png";